import React, { useEffect, useState } from "react";
import { CgMenuGridR } from "react-icons/cg";
import { ChevronDown } from "lucide-react";
import "../../index.css";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import "./style.css";

export default function Navbar({ setOpenSidebar, openSidebar, blogs }) {
  const navigate = useNavigate();
  const [hoverHome, setHoverHome] = useState(false);
  const [hoverMedia, setHoverMedia] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userProfileImage, setUserProfileImage] = useState("");


  useEffect(() => {
    // Check local storage for authentication token
    const token = localStorage.getItem("authToken");
    const profileImage = localStorage.getItem("profileImage");

    if (token) {
      setIsLoggedIn(true);
      setUserProfileImage(profileImage || "defaultProfileImageURL"); // Use a default image if not set
    } else {
      setIsLoggedIn(false);
    }
  }, [])

  useEffect(() => {
    // Check local storage for authentication status and profile image
    const token = localStorage.getItem('authToken');
    const profileImage = localStorage.getItem('profileImage');

    if (token) {
      setIsLoggedIn(true);
      setUserProfileImage(profileImage || 'defaultProfileImageURL'); // Use a default image if not set
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleRegister = () => {
    navigate('/register');
  };

  const HomeLinks = [
    { title: "Geo Locations" },
    { title: "Register", link: "/register" },
    { title: "Sign-In", link: "/login" },
    { title: "Sign-Out" },
  ];

  const MediaLinks = [
    { name: "About Us", id: "0", link: "/About" },
    { name: "Leader Olumba Olumba Obu", id: "1", link: "/Leader" },
    { name: "His Holiness Olumba Olumba Obu", id: "2", link: "/His" },
    { name: "Doctrine", id: "3", link: "/Doctrine" },
    { name: "Sacrament", id: "4", link: "/Sacrament" },
  ];

  return (
    <div>
      <motion.nav
        className="fixed top-5 left-0 right-0 z-50 bg-white shadow-2xl mx-2 md:mx-10 rounded-xl flex items-center h-16 md:h-20 px-2 md:px-10 transition-all duration-300"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 1.5,
          delay: 0.3,
          ease: [0.16, 1, 0.3, 1],
        }}
      >
        <div className="flex justify-between w-full items-center">
          {/* Logo */}
          <Link to="/" onClick={() => window.scrollTo(0, 0)} className="flex-shrink-0">
            <img
              src={'/bcs.png'}
              alt="Logo"
              className="h-10 md:h-14 w-auto"
            />
          </Link>

          {/* Center Links */}
          <ul className="hidden md:flex flex-row space-x-5 uppercase items-center text-xs text-[#003366] font-semibold">
            <Link
              onClick={() => window.scrollTo(0, 0)}
              to={"/"}
              className="flex flex-row items-center cursor-pointer hover:text-blue-600 transition-colors"
            >
              Home
            </Link>
            <li
              className="relative flex flex-row items-center cursor-pointer group"
              onMouseEnter={() => setHoverMedia(true)}
              onMouseLeave={() => setHoverMedia(false)}
            >
              <div className="flex flex-row items-center gap-1 hover:text-blue-600 transition-colors">
                About
                <ChevronDown className={`w-3 h-3 transition-transform duration-300 ${hoverMedia ? 'rotate-180' : ''}`} />
              </div>

              {hoverMedia && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="absolute top-full left-0 w-64 pt-4 z-50"
                  onMouseEnter={() => setHoverMedia(true)}
                >
                  <div className="bg-white rounded-2xl shadow-2xl border border-stone-100 overflow-hidden py-4 px-2">
                    {MediaLinks.map((link, index) => (
                      <Link
                        key={index}
                        to={link.link}
                        onClick={() => {
                          setHoverMedia(false);
                          window.scrollTo(0, 0);
                        }}
                        className="flex items-center px-6 py-3 text-[11px] font-bold text-stone-600 hover:text-blue-600 hover:bg-stone-50 transition-all rounded-xl"
                      >
                        {link.name}
                      </Link>
                    ))}
                  </div>
                </motion.div>
              )}
            </li>

            <li>
              <Link
                to={"/EGC"}
                className="flex flex-row items-center cursor-pointer hover:text-blue-600 transition-colors"
              >
                Sermon
              </Link>
            </li>

            <li
              className="relative cursor-pointer h-full flex items-center gap-1 group"
              onMouseEnter={() => setHoverHome(true)}
              onMouseLeave={() => setHoverHome(false)}
            >
              <div className="flex items-center gap-1 hover:text-blue-600 transition-colors">
                Bethels
                <ChevronDown className={`w-3 h-3 transition-transform duration-300 ${hoverHome ? 'rotate-180' : ''}`} />
              </div>

              {hoverHome && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="absolute top-full left-0 w-56 pt-4 z-50"
                  onMouseEnter={() => setHoverHome(true)}
                >
                  <div className="bg-white rounded-2xl shadow-2xl border border-stone-100 overflow-hidden py-4 px-2">
                    {HomeLinks.map((link, index) => (
                      <Link
                        key={index}
                        to={link.link}
                        onClick={() => setHoverHome(false)}
                        className="flex items-center px-6 py-3 text-[11px] font-bold text-stone-600 hover:text-blue-600 hover:bg-stone-50 transition-all rounded-xl"
                      >
                        {link.title}
                      </Link>
                    ))}
                  </div>
                </motion.div>
              )}
            </li>



            {isLoggedIn && (
              <img
                src={userProfileImage}
                alt="Profile"
                className="h-10 w-10 rounded-full cursor-pointer"
                onClick={() => {
                  // Handle profile image click (e.g., open profile dropdown)
                }}
              />
            )}
          </ul>

          {/* Mobile: Register button next to menu */}
          <div className="flex items-center gap-3 md:hidden">
            {!isLoggedIn && (
              <button
                onClick={handleRegister}
                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-full text-[10px] tracking-widest uppercase font-bold transition-all shadow-lg hover:shadow-red-600/20"
              >
                Register Biodata
              </button>
            )}

            <button
              className="p-2"
              onClick={() => setOpenSidebar(true)}
            >
              <CgMenuGridR className="text-3xl text-red-600" />
            </button>
          </div>

          {/* Right link */}
          <div className="hidden md:flex flex-row space-x-6 items-center">
            {!isLoggedIn && (
              <button
                onClick={handleRegister}
                className="bg-red-600 hover:bg-red-700 text-white px-6 py-2.5 rounded-full text-[11px] tracking-widest uppercase font-bold transition-all shadow-lg hover:shadow-red-600/20"
              >
                Register Biodata
              </button>
            )}
            <CgMenuGridR
              className="h-10 w-10 text-red-600 cursor-pointer hover:scale-110 transition-transform"
              onClick={() => setOpenSidebar(true)}
            />
          </div>

          {/* Mobile menu icon (handled above for small screens) */}
        </div>
      </motion.nav>
    </div>
  );
}
